export const API_URL = `${process.env.REACT_APP_CORS_PROXY_URL}/https://forum.tezosagora.org`;
